import { AuthService } from '@aipb/shared/auth';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CastorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!httpRequest.url.match('/castor7/')) {
      return next.handle(httpRequest);
    }

    if (!this.auth.isLoggedIn()) {
      return next.handle(httpRequest);
    }

    return next.handle(
      httpRequest.clone({
        params: httpRequest.params.set('jwt', this.auth.token)
      })
    );
  }
}
